import * as moment from 'moment';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { Moment } from 'moment';
export class AppDateApdater extends MomentDateAdapter {

    expresionValidadora = new RegExp('^[0-9]{1,2}(\/){1}[0-9]{1,2}(\/){1}[0-9]{4}$');


    parse(value: any): Moment | null {
        let date = null;
        if (value && this.expresionValidadora.test(value)) {
            date = moment(value, 'DD/MM/YYYY');
        }
        return date;
    }
}



// WEBPACK FOOTER //
// ./src/app/adapters/app-date-adapter/app-date-apdater.class.ts